import React from "react";
import ArrowDownIcon from "../../icons/arrow-down.icon";
import styles from "./distributors-table.module.scss";
import cn from "../../../Utils/class-names.utils";

export const DistributorsTableHeader = ({
  columns,
  sortConfig,
  onSort,
}) => {
  const handleSort = (field) => {
    if (onSort) {
      onSort(field);
    }
  };

  return (
    <thead className={styles.tableHeader}>
      <tr className={styles.headerRow}>
        {columns.map((column, index) => {
          const isActive = sortConfig?.field === column.field && sortConfig?.direction !== null;
          const direction = isActive ? sortConfig.direction : null;
          const isSortable = column.sortable !== false && onSort;

          return (
            <th
              key={index}
              className={cn(styles.headerCell, {
                [styles.sortable]: isSortable,
                [styles.firstColumn]: index === 0,
              })}
              onClick={() => isSortable && handleSort(column.field)}
            >
              <div className={styles.headerContent}>
                <span className={styles.headerText}>{column.label}</span>
                {isSortable && isActive && (
                  <div
                    className={cn(styles.arrowWrapper, {
                      [styles.desc]: direction === "desc",
                      [styles.asc]: direction === "asc",
                    })}
                  >
                    <ArrowDownIcon />
                  </div>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

